import React from 'react';
import type { WrapPageElementBrowserArgs } from 'gatsby';
import { ClientEntrypoint } from './src/ClientEntrypoint';
import 'particles.js';

export const wrapPageElement = (args: WrapPageElementBrowserArgs) => {
  return <ClientEntrypoint>{args.element}</ClientEntrypoint>;
};

export { shouldUpdateScroll } from './src/services/NavigationService';
